import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';
import { ArrowRightIcon } from '@root/styles/icons';

const StyledArrowIcon = styled(ArrowRightIcon)`
  color: ${({ theme }) => theme.defaultColors.grey};
  margin: 0 10px;
`;

const DateComponent = styled.span`
  padding-right: 0.2em;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

const DateRangeIndicator = ({ fromDate, toDate, className = null }) => (
  <span className={className}>
    <FormattedDate value={fromDate} month="short" day="numeric" year="numeric">
      {(date) => <DateComponent>{date}</DateComponent>}
    </FormattedDate>
    <StyledArrowIcon width="16" height="16" />
    <FormattedDate value={toDate} month="short" day="numeric" year="numeric">
      {(date) => <DateComponent>{date}</DateComponent>}
    </FormattedDate>
  </span>
);

DateRangeIndicator.propTypes = {
  fromDate: PropTypes.object.isRequired,
  toDate: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default DateRangeIndicator;
